<!--
 * @FileDescription: 往来单位（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container department">
        <div class="page-container-height">
            <div style="display: flex;align-items: center;margin-bottom: 20px">
                <div class="department-add" @click="onEdit(1)" v-has="'system_unit_add'">
                    <img src="@/assets/image/unit_add@2x.png"/>
                    <span>新增往来单位</span>
                </div>
                <div class="department-right-top">
                    <div class="department-top-left">
                        <a-form :form="form" layout="inline" class="unit-form" >
                            <a-form-item>
                                <a-select  v-decorator="['contactCustomerType',{ rules: [{ required: false}] },]"
                                           placeholder="单位类型"
                                >
                                    <a-icon slot="suffixIcon"  type="caret-down" style="color: #555555" />
                                    <a-select-option value="0">
                                        客户
                                    </a-select-option>
                                    <a-select-option value="1">
                                        供应商
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item>
                                <a-input placeholder="请输入关键字查询" v-decorator="['keyword']" class="department-input" @pressEnter="onSearch(1)"></a-input>
                            </a-form-item>
                        </a-form>
                        <a-button class="button-search" @click="onSearch(1)">搜索</a-button>
                        <a-button class="button-search1" @click="onSearch(2)">重置</a-button>
                    </div>
                </div>
            </div>
            <div class="department">
                <div class="department-left">
                    <treeLeft ref="treeLeft" :treeList="treeList" :index="1" :tab="2" @onSelectKey="onSelectKey" @pageListTree="pageListTree" @onSelectAll="onSelectAll"></treeLeft>
                </div>
                <div class="department-right">
                    <a-table :columns="columns"
                             :dataSource="dataSource"
                             :pagination="pagination"
                             bordered
                             @change="handleTableChange"
                             class="table-height"
                             :scroll="{y: 'calc(100vh - 425px)' }"
                             rowKey="key">
                        <template slot="state" slot-scope="text, record">
                             <span :class="record.data3 == 0 ? 'audit-state' : 'audit-state audit-state1'">
                                  <span class="audit-state-cir"></span>
                                  <span v-if="text == 0">在职</span>
                                   <span v-else>离职</span>
                              </span>
                        </template>
                        <template slot="operation" slot-scope="text, record">
                            <div class="operation">
                                <div class="operation-left" @click="onEdit(2,record)" v-has="'system_unit_edit'">详情</div>
                                <div class="operation-left" @click="onEdit(3,record)" >收货地址</div>
                                <div class="operation-right">
                                    <div class="operation-item" @click="onDelete(record)" v-has="'system_unit_delete'">
                                        <a href="javascript:;" >
                                            <img src="@/assets/image/cha_shanchu_color.png" class="operation-item-img" />
                                            <img src="@/assets/image/cha_shanchu.png" class="operation-item-img1"/>
                                        </a>
                                        <!--<a-popconfirm-->
                                                <!--v-if="dataSource.length"-->
                                                <!--title="确定删除?"-->
                                                <!--@confirm="() => onDelete(record.id)"-->
                                        <!--&gt;-->
                                           <!---->
                                        <!--</a-popconfirm>-->
                                    </div>
                                </div>
                            </div>
                        </template>
                    </a-table>
                </div>
            </div>
        </div>
        <unitModel ref="unitModel" :treeList="treeList" @onPageList="onPageList"></unitModel>
        <deleteModal ref="deleteModal" @confirmDeletion="confirmDeletion"></deleteModal>
    </div>
</template>
<script>
    import picture from "@/components/upload/picture.vue"
    import {getfindDepart,contactList,conditionList,conditionDelete,arealist} from "@/utils/api";
    import treeLeft from './model/TreeLeft'
    import {mixins} from "@/mixins/mixins";
    import AFormItem from "ant-design-vue/es/form/FormItem";
    import unitModel from './model/unitModel'
    import deleteModal from '@/components/module/deleteModal'
    export default {
        mixins:[mixins],
        data () {
            return {
                form: this.$form.createForm(this),
                treeList:[],
                columns: [
                    {
                        title: '',
                        dataIndex: '',
                        key: 'rowIndex',
                        width: 80,
                        align: "center",
                        customRender: function (t, r, index) {
                            return parseInt(index) + 1;
                        }
                    },
                    {
                        title: '编号',
                        key: 'code',
                        dataIndex: 'code',
                        ellipsis: true,
                    },
                    {
                        title: '联系人',
                        key: 'contactName',
                        dataIndex: 'contactName',
                        ellipsis: true,
                    },
                    {
                        title: '单位名称',
                        key: 'contactCustomerName',
                        dataIndex: 'contactCustomerName',
                        ellipsis: true,
                    },
                    {
                        title: '联系电话',
                        dataIndex: 'mobile',
                        key: 'mobile',
                        ellipsis: true,
                    },
                    {
                        title: '单位类型',
                        key: 'contactCustomerType',
                        dataIndex: 'contactCustomerType',
                        ellipsis: true,
                        customRender: function (t, r, index) {
                            if(t.charAt(0) == 0 && t.charAt(2) == 1){
                                return '客户，供应商'
                            }else if(t.charAt(0) == 0){
                                return '客户'
                            }else if(t.charAt(0) == 1){
                                return '供应商'
                            }
                        }
                    },
                    {
                        title: '单位类别',
                        key: 'categoryName',
                        dataIndex:'categoryName',
                      ellipsis: true,
                    },
                    {
                        title: '区域',
                        key: 'areaName',
                        dataIndex:'areaName',
                        ellipsis:true,
                        ellipsis: true,
                    },
                    {
                        title: '操作',
                        width:150,
                        scopedSlots: { customRender: 'operation' },
                    },
                ],
                dataSource: [],
                selectKey:'',
                options: [],
                formObj:{},
            }
        },
        components: {
            AFormItem,
            'v-picture':picture,
            treeLeft,
            unitModel,
            deleteModal
        },
        watch: {
            pageList: {
                handler(newValue, oldValue) {
                    if(!this.isEmpty(newValue.result)){
                        this.dataSource = newValue.result.records
                        this.pagination.current = newValue.result.current
                        this.pagination.total =newValue.result.total
                        this.pagination.pageSize = newValue.result.size
                        this.pages = this.pageList.result.pages
                        this.$store.state.isLoding = false
                    }
                },
                deep: true
            },
        },
        mounted () {
            this.pagination.pageSize = 40
            this.getDepartMessage()
            this.getfindStaffAllMessage()
        },
        created () {

        },
        methods: {
            /**
             * @description: 获取全部类别信息（方法描述）
             */
            getDepartMessage(){
                let data = new FormData()
                data.append('companyStoreId',this.$store.state.shopId)
                contactList(data,{'Content-Type':'application/json'}).then((res)=>{
                    if(res.success){
                        res.result.forEach((item)=>{
                            item.isCheck = false
                            item.isActive = false
                            item.name1 = item.name
                        })
                        this.treeList = res.result
                    }
                })
            },
            pageListTree(){
               this.getDepartMessage()
            },
            onPageList(index){
               this.getfindStaffAllMessage()
            },
            /**
             * @description: 获取往来单位信息（方法描述）
             */
            getfindStaffAllMessage(){
                this.$store.state.isLoding = true
                this.formObj.companyStoreId = this.$store.state.shopId
                this.formObj.contactCustomerCategoryId = this.selectKey
                this.formObj.pageNo = this.pagination.current
                this.formObj.pageSize = this.pagination.pageSize
                this.getPageList('/system/api/contactCustomer/listByConditions',
                        this.formObj,{
                            'Content-Type':'application/json'
                        })
            },
            /**
             * @description: 分类回调（方法描述）
             */
            onSelectKey(values){
                this.selectKey = values
                this.pagination.current = 1
                this.getfindStaffAllMessage()
            },
            /**
             * @description: 搜索（方法描述）
             */
            onSearch(index){
                if(index == 1){
                    this.form.validateFields((err, values) => {
                        if(!err){
                            this.formObj.contactCustomerType = values.contactCustomerType
                            this.formObj.keyword = values.keyword
                            this.pagination.current = 1
                            this.getfindStaffAllMessage()
                        }
                    })
                }else if(index == 2){
                    this.form = this.$form.createForm(this)
                    this.formObj.contactCustomerType = ''
                    this.formObj.keyword = ''
                    this.pagination.current = 1
                    this.getfindStaffAllMessage()
                }

            },
            /**
             * @description: 删除（方法描述）
             */
            onDelete(record){
                record.content = '您确认要删除往来单位吗'
                this.$refs.deleteModal.show(record)
            },
            confirmDeletion(record){
                let data = new FormData()
                data.append('id',record.id)
                data.append('companyStoreId',this.$store.state.shopId)
                conditionDelete(data,{}).then((res)=>{
                    if(res.success){
                        this.$message.success(res.logMessage)
                        this.getfindStaffAllMessage()
                    }else{
                        this.$message.warn(res.logMessage)
                    }
                })
            },
            /**
             * @description: 表格页数切换（方法描述）
             */
            handleTableChange(pagination, filters, sorter){
                this.pagination.current = pagination.current
                this.pagination.pageSize = pagination.pageSize
                this.getfindStaffAllMessage()
            },
            /**
             * @description: 新增和编辑员工信息（方法描述）
             */
            onEdit(index,record){
                if(index== 1){
                    this.$refs.unitModel.onOpen(1,{})
                }else if(index == 2){
                    this.$refs.unitModel.onOpen(2,record)
                }else if(index == 3){
                    this.$refs.unitModel.onOpen(3,record)
                }
            },
            /**
             * @description: 全部类别（方法描述）
             */
            onSelectAll(){
                this.selectKey = ''
                this.getfindStaffAllMessage()
            },
            /**
             * @description: 区域选择（方法描述）
             */
            onChangePrice(value, selectedOptions) {
                console.log(value,selectedOptions)
                // this.formObj.provinceId = value[0]
                // this.formObj.cityId = value[1]
                // this.formObj.countyId = value[2]
            },
        },
    }
</script>
<style lang="scss">
    .department{
        .page-container{
            min-height: calc(100% - 500px);
        }
        .page-container-height{
            height: 100%;
        }
        .ant-table-wrapper{
            padding: 0;
        }
        .ant-tree li{
            line-height: 36px;
            padding: 0 !important;
        }
        .ant-tree.ant-tree-directory > li span.ant-tree-node-content-wrapper::before, .ant-tree.ant-tree-directory .ant-tree-child-tree > li span.ant-tree-node-content-wrapper::before{
            height: 36px !important;
        }
        .ant-tree li span.ant-tree-switcher, .ant-tree li span.ant-tree-iconEle{
            line-height: 30px !important;
        }
        .ant-tree li .ant-tree-node-content-wrapper{
            line-height: 36px !important;
            flex: 1;
            height: 36px;
            width: 100%;
        }
        .ant-tree-title{
            width: 71%;
            display: inline-block;
        }
        .tree-span{
            width: 100%;
            display: inline-block;
        }
        .form-left{
            flex: 1;
            padding-left: 40px;
            .ant-input{
                width: 200px;
            }
            .ant-col-12{
                padding-left: 20px;
                width: 55%;
            }
        }
        .model-form{
            .model-footer{
                padding-left: 18% !important;
            }
        }
        .down-up{
            width:120px;
            height:40px;
            border:1px solid #DDDDDD;
            border-radius:2px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            .down-up-icon{
                color: #AAAAAA;
                padding-right: 5px;
            }
            .input-file{
                position: absolute;
                top: 0;
                left: 0;
                width: 120px;
                height: 40px;
                display: inline-block;
                opacity: 0;
            }
        }
        .ant-tree-treenode-selected > span.ant-tree-node-content-wrapper::before{
            background: rgba(247,111,20,0.1)!important;
        }
        .ant-tree-node-content-wrapper.ant-tree-node-selected{
            color: #333333!important;
        }
        .tree-input{
            .ant-input{
                height: 28px !important;
                line-height:28px !important;
            }
        }
        .unit-form{
            .ant-select{
                width: 200px;
            }
        }
        .table-height{
            .ant-table{
                height: calc(100vh - 320px);
            }
            .ant-table-body,.ant-table-body-inner{
                max-height: calc(100vh - 380px) !important;
            }
        }
        .ant-form-item:last-child{
            margin-right: 0 !important;
        }
    }
</style>
<style lang="scss" scoped>
    .page-container{
        background: #FFFFFF;
        padding: 0;
    }
    .page-container-height{
        padding: 20px 18px 0 29px;
        .department-add{
            cursor: pointer;
            width: 200px;
            display: flex;
            align-items: center;
            font-weight: 700;
            color: var(--co);
            img{
                width: 40px;
                margin-right: 12px;
            }
        }
        .department-right-top{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .department-top-left{
                display: flex;
                .department-input{
                    width: 260px;
                    margin-right: 16px;
                }
            }
        }
        .department{
            display: flex;
        }
        .department-left{
            flex: 0 0 190px;
            border: 1px solid #EEEEEE;
            padding-top: 20px;
            padding-left: 10px;
            height: calc(100vh - 320px);
            .department-left-top{
                padding-left: 3px;
                padding-bottom: 10px;
                img{
                    width: 16px;
                    margin-left: 5px;
                }
            }
        }
        .department-right{
            flex: 1;
            margin-left: 8px;
            overflow: hidden;
            .operation{
                display: flex;
                .operation-left{
                    color: #387BFC;
                    margin-right: 10px;
                    cursor: pointer;
                }
                .operation-right{
                    cursor: pointer;
                }
            }
        }
    }
    .upload-img{
        display: flex;
        align-items: center;
        justify-content: center;
        .upload-img-left{
            position: relative;
            img{
                width: 100px;
                height: 100px;
            }
            .upload-delete{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100px;
                height: 24px;
                background:rgba(0,0,0,0.3);
                display: flex;
                justify-content: flex-end;
                align-items: center;
                .upload-delete-icon{
                    color: #FFFFFF;
                    font-size: 16px;
                    padding-right: 6px;
                }
            }
        }
        .upload-more{
            color: #387BFC;
            font-size: 14px;
            position: relative;
            padding-left: 10px;
            .input-file{
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                opacity: 0;
                width: 56px;
                height: 40px;
            }
        }
    }
    .tree-span{
        img{
            width: 11px;
            height: 12px;
            margin-left: 8px;
        }
        .tree-input{
            width: 100px;
            height: 28px !important;
            line-height: 28px !important;
        }
    }
</style>
